export type Tema = 'claro' | 'escuro';

export function temaAtual(): Tema {
  return document.documentElement.classList.contains('dark') ? 'escuro' : 'claro';
}

export function alternarTema(): Tema {
  const novo: Tema = temaAtual() === 'escuro' ? 'claro' : 'escuro';
  document.documentElement.classList.toggle('dark', novo === 'escuro');
  try {
    localStorage.setItem('tema', novo);
  } catch {
    /* modo privado */
  }
  return novo;
}
